import initialState from './initialState';
import {
  UPDATE_CONFIGURATION_DEFAULTS,
  UPDATE_CONFIGURATION_DEFAULTS_DONE,
  UPDATE_CONFIGURATION_DEFAULTS_ERROR,
  UPDATE_CONFIGURATION_DEFAULTS_LOADING,
  UPDATE_CONFIGURATION_DEFAULTS_SUCCESS
} from '../actions/actionTypes';

// handles Configuration defaults related actions

const reducerConfigurationDefaults = (state, action) => {
  switch (action.type) {
    case UPDATE_CONFIGURATION_DEFAULTS_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };
    case UPDATE_CONFIGURATION_DEFAULTS_SUCCESS:
      return {
        ...state,
        error: null
      };
    case UPDATE_CONFIGURATION_DEFAULTS_ERROR:
      return {
        ...state,
        error: action.error
      };
    case UPDATE_CONFIGURATION_DEFAULTS_DONE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  if (action.type.startsWith(UPDATE_CONFIGURATION_DEFAULTS)) {
    return reducerConfigurationDefaults(state, action);
  } else {
    return state;
  }
};
